webpackJsonp([254572558124955],{

/***/ 1316:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"","searchOnlyApiKey":"","indexName":""}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---search-84269fabafea3eec14cf.js